var map = {
	"./SEL.svg": 2766,
	"./copadata-logo.svg": 7067,
	"./etap.svg": 3654,
	"./ge.svg": 2386,
	"./siemens.svg": 7204,
	"./wonderware.svg": 5680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9780;